import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { memo, useCallback, useState } from "react";
import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { Box, Button, Modal, Space, Stack, Text, Textarea, Title, } from "@mantine/core";
import { useForm } from "@mantine/form";
import { CheckGreen } from "../../assets/icons.generated";
import { logError } from "../../services/logger";
import { useCreateFeedbackMutation } from "./feedback.graphql.generated";
export const FeedbackModal = ({ isOpen, onClose }) => {
    const form = useForm({
        initialValues: {
            description: "",
        },
        validate: (values) => ({
            description: !values.description ? "Field is required" : null,
        }),
    });
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [createFeedback, { loading }] = useCreateFeedbackMutation({
        notifyOnNetworkStatusChange: true,
    });
    const resetSubmissionStates = useCallback(() => {
        setSuccess(false);
        setError(false);
    }, []);
    const handleClose = useCallback(() => {
        resetSubmissionStates();
        form.clearErrors();
        onClose();
    }, [onClose, resetSubmissionStates, form]);
    return (_jsxs(Modal, { size: "lg", opened: isOpen, onClose: handleClose, withCloseButton: !success, title: !success && (_jsx(Text, { size: "lg", weight: 500, children: "Request a feature" })), children: [!success ? (_jsxs(_Fragment, { children: [_jsx(Box, { children: "We're always looking for ways to make Highlight better and would love to hear what you\u2019d like us to build next." }), _jsx(Space, { h: "sm" }), _jsxs(Box, { component: "form", onChange: resetSubmissionStates, onSubmit: form.onSubmit(async (values) => {
                            resetSubmissionStates();
                            try {
                                await createFeedback({
                                    variables: {
                                        feedback: {
                                            description: values.description,
                                            url: window.location.href,
                                        },
                                    },
                                });
                                setSuccess(true);
                                form.reset();
                            }
                            catch (e) {
                                setError(true);
                                await logError({
                                    e,
                                    message: "[Feedback] Failed to send feedback",
                                });
                            }
                        }), children: [_jsx(Textarea, { styles: {
                                    input: {
                                        height: "100px",
                                        marginTop: 0,
                                    },
                                }, size: "sm", placeholder: "Let us know what feature you\u2019d like to see in Highlight...", maxRows: 5, maxLength: 1000, ...form.getInputProps("description") }), _jsx(ModalSection, { children: _jsx(Button, { type: "submit", size: "xl", fullWidth: true, loading: loading, onClick: resetSubmissionStates, children: "Submit" }) })] })] })) : (_jsxs(Stack, { px: "lg", mt: "sm", spacing: "xs", align: "center", children: [_jsx(Space, { h: "lg" }), _jsx(CheckGreen, { height: 32, width: 32 }), _jsx(Title, { order: 5, children: "Feature request submitted" }), _jsx(ModalSection, { children: _jsx(Button, { fullWidth: true, size: "xl", onClick: handleClose, children: "Done" }) })] })), error && (_jsxs(_Fragment, { children: [_jsx(Space, { h: "sm" }), _jsx(Text, { size: "xs", mb: "xs", color: STATUS_COLOR.ERROR, px: "lg", children: "Error trying to send feedback." })] }))] }));
};
export default memo(FeedbackModal);
